<template>
  <div>
    <HowToInvestMain></HowToInvestMain>

    <AppFooter></AppFooter>
  </div>

</template>

<script>

import AppFooter from "@/components/AppFooter.vue";
import FDinCarouselService from "@/services/apiservices/f-din-carousel-service";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css"; // Tema Snow
import "quill/dist/quill.bubble.css";
import HowToInvestMain from "@/components/beranda/how-to-invest/HowToInvestMain.vue"; // Tema Bubble (opsional)

export default {
  name: 'TugasDanFungsiView',
  components: {
    HowToInvestMain,
    AppFooter,
  },
  data() {
    return {
      constDinCarouselTypeBean: 801,

      itemDefault: "",
      itemModified: "",

      customToolbar: [[]],
      customToolbarX: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block"]
      ],
      editorOptions: {
        theme: null, // Tidak ada tema
        modules: {
          toolbar: false // Menghilangkan toolbar
        }
      }


    }
  },
  methods: {
    initializeEditMode() {

      FDinCarouselService.getAllFDinCarouselByTypePublic(this.constDinCarouselTypeBean).then(
          (response) => {
            const items = response.data;

            if (items.length >0) {
              this.itemDefault = Object.assign({}, items[0]);
              this.itemModified = items[0];
            }

          },
          (error) => {
            console.log(error);
          }
      )
    },
  },
  mounted() {
    this.initializeEditMode();
  }
}
</script>


<style scoped></style>
